<template>
    <div id="vehicle_model_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="vehicleModelHeader" v-if="$route.params.id > 0">Update Fuel Reading</span>
                    <span class="page-title" id="vehicleModelHeader" v-else>Add Fuel Reading</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackFuelReadingList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="VehicleModelForm">
                                <div class="field-error" v-if="user_location_error!=''">
                                    {{user_location_error}}
                                </div>
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col">
                                        <label class="control-label require" for="reading_date">Date :</label>
                                        <date-picker placeholder="MM/DD/YYYY" id="reading_date" name="reading_date" v-model="reading_date" :config="optionsDate"></date-picker>
                                        <div class="field-error">{{ reading_date_error_msg }}</div>
                                    </div>
                                </div>
                                <template v-for="(product,key) in productArr">
                                    <h5 v-bind:key="'pro'+key" class="mt-4">
                                            <!-- {{product.tank_no}} | {{product.item}} | {{ product.location }} -->
                                             {{product.tank_no}}
                                    </h5>
                                    <div :key="key" class="form-row row-cols-md-4 row-cols-1">
                                        <div class="col form-group">
                                            <template v-if="product.item_code == 'DEF'">
                                                <label class="control-label require" for="start_tank_reading">Start Tank Reading (Gallons):</label>
                                            </template>
                                            <template v-else>
                                                <label class="control-label require" for="start_tank_reading">Start Tank Reading (Inches):</label>
                                            </template>    
                                            <input type="text" class="form-control" v-model="product.start_tank_reading" id="start_tank_reading" maxlength="8" @input="calculateTankTotal(key)" placeholder="Enter Reading." name="start_tank_reading" @keypress="isAmountCheck($event)">
                                            <div class="field-error">{{product.start_tank_reading_error}}</div>
                                        </div>
                                        <div class="col form-group">
                                            <template v-if="product.tank == 2">
                                                <label class="control-label" for="end_tank_reading">End Tank Reading (Gallons):</label>
                                            </template>
                                            <template v-else>
                                                <label class="control-label" for="end_tank_reading">End Tank Reading (Inches):</label>
                                            </template>        
                                            <input type="text" class="form-control" v-model="product.end_tank_reading" id="end_tank_reading" maxlength="8" @input="calculateTankTotal(key)" placeholder="Enter Reading." name="end_tank_reading" @keypress="isAmountCheck($event)">
                                            <div class="field-error">{{product.end_tank_reading_error}}</div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label" for="tank_reading_total">Total Tank Reading:</label>
                                            <input type="number" class="form-control" disabled v-model="product.tank_reading_total" id="tank_reading_total" placeholder="Total Reading" name="tank_reading_total">
                                        </div>
                                        <template v-if="product.tank != 2">
                                            <div class="clearfix"></div>
                                            <div class="col form-group">
                                                <label class="control-label" for="start_meter_reading">Start Meter Reading:</label>
                                                <input type="text" class="form-control" v-model="product.start_meter_reading" maxlength="8"  id="start_meter_reading" @input="calculateMeterTotal(key)" placeholder="Enter Reading." name="start_meter_reading" @keypress="isAmountCheck($event)">
                                                <div class="field-error">{{product.start_meter_reading_error}}</div>
                                            </div>
                                            <div class="col form-group">
                                                <label class="control-label" for="end_meter_reading">End Meter Reading:</label>
                                                <input type="text" class="form-control" v-model="product.end_meter_reading" maxlength="8"  id="end_meter_reading" @input="calculateMeterTotal(key)" placeholder="Enter Reading." name="end_meter_reading" @keypress="isAmountCheck($event)">
                                                <div class="field-error">{{product.end_meter_reading_error}}</div>
                                            </div>
                                            <div class="col form-group">
                                                <label class="control-label" for="meter_reading_total">Total Meter Reading:</label>
                                                <input type="number" class="form-control" disabled v-model="product.meter_reading_total"  id="meter_reading_total" placeholder="Total Reading." name="meter_reading_total">
                                            </div>
                                        </template>
                                    </div>
                                </template>
                                <template v-if="productArr.length == 0">
                                    <span>No Product Found.</span>
                                </template>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-col-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateFuelReadingBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateFuelReading" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateFuelReadingBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateFuelReading" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="cancelVehicleModelBtn" class="btn btn-tertiary" v-on:click.prevent="BackFuelReadingList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>    
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";
import moment from 'moment'
import {commonMixins} from '../mixins/commonMixins';

 



export default {
  name: "VehicleModelCreate",
  
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Fuel Reading | " +process.env.COPYRIGHT_NAME : "Create Fuel Reading | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
      loading:false,
      reading_date:moment().format("MM/DD/YYYY"),
      productArr:[],
      productReadingArr:[],
      optionsDate: {
          format: 'MM/DD/YYYY',
          useCurrent: true,
      },
      reading_date_error_msg:"",
      user_location_error:"",
      endShift:false,
      from_fuel_ticket:false,

  }),
  watch: {

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_fuel_reading') {
                        self.cantAccessPage = true;

                    }
                }
            }

        }
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();

        var path = window.location.pathname;
        var segments = path.split("/");
          if(self.$route.query.flag == 'fuelTicket') {
              self.from_fuel_ticket=true;

          }
        if (segments[3]) {
            if(self.$route.query.flag == 'end_shift') {
                self.endShift=true;
            }

            self.loadReading();
        }else{
            self.loadProducts();
        }
  },
  methods: {

    BackFuelReadingList() {
      var self = this;
        if(self.from_fuel_ticket==true)
        {
            self.$router.push("/fuel-ticket/list");
        }else{
            self.$router.push("/fuel-reading/list");
        }
    },
    calculateTankTotal(key){

      var self = this;
      var start=0;
      var end=0;
      var total=0;
      if (self.productArr[key]['start_tank_reading'] != null && self.productArr[key]['start_tank_reading'] != "") {
        start=parseFloat(self.productArr[key]['start_tank_reading']);
      }
      if (self.productArr[key]['end_tank_reading'] != null && self.productArr[key]['end_tank_reading'] != "") {
        end=parseFloat(self.productArr[key]['end_tank_reading']);
      }


          if (start != 0 || end != 0) {
              self.productArr[key]['start_tank_reading_error'] ="";
              self.productArr[key]['end_tank_reading_error'] ="";
              total = start - end;//start - end
              self.productArr[key]['tank_reading_total'] = parseFloat(total);
          } else {
              total = 0;
              self.productArr[key]['tank_reading_total'] = total;
          }

    },
      calculateMeterTotal(key){

          var self = this;
          var start=0;
          var end=0;
          var total=0;
          if (self.productArr[key]['start_meter_reading'] != null && self.productArr[key]['start_meter_reading'] != "") {
            start=parseFloat(self.productArr[key]['start_meter_reading']);
          }
          if (self.productArr[key]['end_meter_reading'] != null && self.productArr[key]['end_meter_reading'] != "") {
            end=parseFloat(self.productArr[key]['end_meter_reading']);
          }

          if(start != 0 || end != 0)
          {
              self.productArr[key]['start_meter_reading_error']="";
              self.productArr[key]['end_meter_reading_error']="";
              total = start - end;
              self.productArr[key]['meter_reading_total']=total;
          }else{
              total=0;
              self.productArr[key]['meter_reading_total']=total;
          }
      },
    loadProducts(){
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/fuel-product/list",
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if(data.status=='location_error')
                {
                    self.user_location_error="User not mapped with any location please contact admin.";
                }
                if(data.status=='success'){

                    self.productArr=data.content;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'fuel-product-load-by-location')
            }
        });
    },
    loadReading(){
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;

        $.ajax({
            url: process.env.ROOT_API + "/fuel-reading/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                        self.productArr=data.content;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'asset-model-load-by-id')
            }
        });

    },
    CreateFuelReading(flag) {
      var self = this;
      var error = false;

      self.reading_date_error_msg = "";

        if (!self.reading_date || self.reading_date == null || self.reading_date == "" ) {
            self.reading_date = "Date Required.";
            error = true;
        }

        var readingArray = [];
        if(self.productArr.length > 0) {

            for (var i = 0; i < self.productArr.length; i++) {

                readingArray.push({
                    product_id: self.productArr[i]['product_id'],
                    start_tank_reading:  self.productArr[i]['start_tank_reading'],
                    end_tank_reading: self.productArr[i]['end_tank_reading'],
                    start_meter_reading: self.productArr[i]['start_meter_reading'],
                    end_meter_reading:  self.productArr[i]['end_meter_reading'],
                    tank_reading_total:  self.productArr[i]['tank_reading_total'],
                    meter_reading_total:  self.productArr[i]['meter_reading_total'],
                    id:self.productArr[i]['id'],
                });

                self.productArr[i]['start_tank_reading_error']="";
                self.productArr[i]['start_meter_reading_error']="";
                self.productArr[i]['end_tank_reading_error']="";
                self.productArr[i]['end_meter_reading_error']="";
                if(self.productArr[i]['start_tank_reading'] <= 0)
                {

                    self.productArr[i]['start_tank_reading_error']="Reading Required";

                    error=true;
                }
                if(self.endShift==true) {

                    if (self.productArr[i]['end_tank_reading'] <= 0) {
                        self.productArr[i]['end_tank_reading_error'] = "Reading Required";
                        error = true;
                    }
                    if (productArr[i]['item_code'] != "DEF") {
                        if (self.productArr[i]['start_meter_reading'] <= 0) {
                            self.productArr[i]['start_meter_reading_error'] = "Reading Required";
                            error = true;
                        }
                        if (self.productArr[i]['end_meter_reading'] <= 0) {
                            self.productArr[i]['end_meter_reading_error'] = "Reading Required";
                            error = true;
                        }
                    }
                }

                    /*var startTank=parseFloat(self.productArr[i]['start_tank_reading']);
                    var endTank=parseFloat(self.productArr[i]['end_tank_reading']);
                    // self.productArr[i]['end_tank_reading_error']='';
                    var starttotal=0;
                    if (endTank > 0 && startTank > 0) {
                       if (endTank > startTank) {
                           starttotal = 0;
                           self.productArr[i]['tank_reading_total'] = starttotal;
                           self.productArr[i]['end_tank_reading_error'] = 'End Reading Must be Less than Start Reading';
                           error = true;
                       } else {
                            starttotal = startTank - endTank;
                            self.productArr[i]['tank_reading_total'] = starttotal;
                       }
                    }

                    var startMeter=parseFloat(self.productArr[i]['start_meter_reading']);
                    var endMeter=parseFloat(self.productArr[i]['end_meter_reading']);
                    var metertotal=0;
                if (startMeter > 0 && endMeter > 0) {
                    self.productArr[i]['end_meter_reading_error'] = "";
                    if (startMeter > endMeter) {
                        metertotal = 0;
                        self.productArr[i]['meter_reading_total'] = metertotal;
                        self.productArr[i]['end_meter_reading_error'] = 'End Reading Must Be Greater than Start Reading';
                        error = true;
                    } else {
                        metertotal = endMeter - startMeter;
                        self.productArr[i]['meter_reading_total'] = metertotal;
                    }
                }*/

            }
        }else{

            error=true;
        }

      if (!error) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateFuelReadingBtn").val("Updating ...");
                $("#CreateFuelReadingBtn").prop("disabled", true);
                $("#cancelVehicleModelBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueVehicleModelBtn").val("Saving ...");
                    $("#CreateFuelReadingBtn").prop("disabled", true);
                    $("#createAndContinueVehicleModelBtn").prop("disabled", true);
                    $("#cancelVehicleModelBtn").prop("disabled",true);

                }else{

                    $("#CreateFuelReadingBtn").val("Saving ...");
                    $("#CreateFuelReadingBtn").prop("disabled", true);
                    $("#createAndContinueVehicleModelBtn").prop("disabled", true);
                    $("#cancelVehicleModelBtn").prop("disabled",true);
                }
               
            }
            var fields = $('#VehicleModelForm').serializeArray();
            fields.push({name: "reading_date", value: self.reading_date});
            fields.push({name:"readings",value: JSON.stringify(readingArray)});
            fields.push({name: "id", value: segments[3]});


            $.ajax({
                url: process.env.ROOT_API + "/fuel-reading/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateFuelReadingBtn").val("Update");
                        $("#CreateFuelReadingBtn").prop("disabled", false);
                        $("#cancelVehicleModelBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueVehicleModelBtn").val("Save and Continue");
                            $("#CreateFuelReadingBtn").prop("disabled", false);
                            $("#createAndContinueVehicleModelBtn").prop("disabled", false);
                            $("#cancelVehicleModelBtn").prop("disabled",false);

                        }else{

                            $("#CreateFuelReadingBtn").val("Save");
                            $("#CreateFuelReadingBtn").prop("disabled", false);
                            $("#createAndContinueVehicleModelBtn").prop("disabled", false);
                            $("#cancelVehicleModelBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {
                        if(self.from_fuel_ticket==true)
                        {
                            self.$router.push("/fuel-ticket/create");
                        }else{
                            self.$router.push("/fuel-reading/list");
                        }
                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateFuelReadingBtn").val("Update");
                        $("#CreateFuelReadingBtn").prop("disabled", false);
                        $("#cancelVehicleModelBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            // $("#VehicleStatusForm").trigger("reset");
                            
                            $("#createAndContinueVehicleModelBtn").val("Save and Continue");
                            $("#CreateFuelReadingBtn").prop("disabled", false);
                            $("#createAndContinueVehicleModelBtn").prop("disabled", false);
                            $("#cancelVehicleModelBtn").prop("disabled",false);

                        }else{

                            $("#CreateFuelReadingBtn").val("Save");
                            $("#CreateFuelReadingBtn").prop("disabled", false);
                            $("#createAndContinueVehicleModelBtn").prop("disabled", false);
                            $("#cancelVehicleModelBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'fuel-reading-create')
                }
            });  
      }else{
                self.errorValidationFocus();
      }
    },
  }
};
</script>   


// WEBPACK FOOTER //
// src/components/FuelReadingCreate.vue